export interface DubaiProduct {
  id: string;
  name: string;
  samplePrice: number;
  bulkPrice: number;
  moq: number;
  image: string;
  category: string;
}

export interface DubaiFactory {
  id: string;
  name: string;
  city: string;
  established: number;
  employees: string;
  verified: boolean;
  dropshipping: boolean;
  warehouseCountries?: string[];
  rating: number;
  responseRate: string;
  onTimeDelivery: string;
  productCount: number;
  categories: string[];
  description: string;
  logo: string;
  coverImage: string;
  products: DubaiProduct[];
}

export const dubaiFactories: DubaiFactory[] = [
  {
    id: "df1",
    name: "Al Futtaim Industrial Group",
    city: "Dubai",
    established: 2008,
    employees: "500–1000",
    verified: true,
    dropshipping: true,
    warehouseCountries: ["UAE", "Saudi Arabia", "UK", "USA", "Germany"],
    rating: 4.9,
    responseRate: "98%",
    onTimeDelivery: "97%",
    productCount: 1240,
    categories: ["Electronics", "Machinery", "Auto Parts"],
    description: "Leading industrial manufacturer in Dubai with 15+ years of excellence. Specializing in smart electronics and industrial machinery for global B2B buyers.",
    logo: "https://public.readdy.ai/ai/img_res/32e205c9fd984a29d80519a877ccf33e.jpg",
    coverImage: "https://readdy.ai/api/search-image?query=modern%20industrial%20factory%20interior%20Dubai%20UAE%20machinery%20production%20line%20workers%20professional%20clean%20bright&width=800&height=400&seq=dfc1&orientation=landscape",
    products: [
      {
        id: "df1p1",
        name: "Industrial LED Smart Panel 200W",
        samplePrice: 120,
        bulkPrice: 45,
        moq: 50,
        category: "Electronics",
        image: "https://readdy.ai/api/search-image?query=industrial%20LED%20smart%20panel%20200W%20modern%20lighting%20product%20white%20clean%20background%20professional%20product%20photography&width=400&height=400&seq=df1p1&orientation=squarish",
      },
      {
        id: "df1p2",
        name: "Heavy Duty Auto Spare Parts Kit",
        samplePrice: 85,
        bulkPrice: 32,
        moq: 100,
        category: "Auto Parts",
        image: "https://readdy.ai/api/search-image?query=heavy%20duty%20auto%20spare%20parts%20kit%20professional%20white%20background%20product%20photography%20industrial%20components&width=400&height=400&seq=df1p2&orientation=squarish",
      },
      {
        id: "df1p3",
        name: "Industrial Conveyor Belt System",
        samplePrice: 450,
        bulkPrice: 180,
        moq: 5,
        category: "Machinery",
        image: "https://readdy.ai/api/search-image?query=industrial%20conveyor%20belt%20system%20machinery%20white%20background%20product%20photography%20professional%20manufacturing%20equipment&width=400&height=400&seq=df1p3&orientation=squarish",
      },
    ],
  },
  {
    id: "df2",
    name: "Dubai Tech Solutions FZE",
    city: "Dubai Free Zone",
    established: 2010,
    employees: "1000+",
    verified: true,
    dropshipping: true,
    warehouseCountries: ["UAE", "China", "USA", "UK", "Australia", "Canada"],
    rating: 4.9,
    responseRate: "99%",
    onTimeDelivery: "98%",
    productCount: 2100,
    categories: ["Electronics", "Smart Devices", "Accessories"],
    description: "Top-tier electronics manufacturer in Dubai Free Zone. Specializing in smart home devices, security cameras, and wireless accessories with global dropshipping.",
    logo: "https://readdy.ai/api/search-image?query=tech%20company%20logo%20gold%20circuit%20emblem%20white%20background%20Dubai%20technology%20corporate%20identity%20minimalist%20modern&width=80&height=80&seq=dfl2&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=modern%20electronics%20factory%20Dubai%20clean%20room%20production%20smart%20devices%20assembly%20line%20professional%20bright&width=800&height=400&seq=dfc2&orientation=landscape",
    products: [
      {
        id: "df2p1",
        name: "Smart Home Security Camera 4K",
        samplePrice: 95,
        bulkPrice: 35,
        moq: 10,
        category: "Electronics",
        image: "https://readdy.ai/api/search-image?query=smart%20home%20security%20camera%204K%20modern%20sleek%20design%20white%20background%20product%20photography%20professional%20tech&width=400&height=400&seq=df2p1&orientation=squarish",
      },
      {
        id: "df2p2",
        name: "Wireless Bluetooth Earbuds Pro",
        samplePrice: 55,
        bulkPrice: 18,
        moq: 30,
        category: "Electronics",
        image: "https://readdy.ai/api/search-image?query=wireless%20bluetooth%20earbuds%20pro%20modern%20sleek%20design%20white%20background%20product%20photography%20professional%20audio%20tech&width=400&height=400&seq=df2p2&orientation=squarish",
      },
      {
        id: "df2p3",
        name: "Smart LED Strip Light 5m RGB",
        samplePrice: 28,
        bulkPrice: 9,
        moq: 100,
        category: "Smart Devices",
        image: "https://readdy.ai/api/search-image?query=smart%20LED%20strip%20light%205m%20RGB%20colorful%20modern%20white%20background%20product%20photography%20professional%20home%20decor&width=400&height=400&seq=df2p3&orientation=squarish",
      },
    ],
  },
  {
    id: "df3",
    name: "Emirates Gold Jewellery LLC",
    city: "Dubai Gold Souk",
    established: 2005,
    employees: "200–500",
    verified: true,
    dropshipping: false,
    rating: 4.8,
    responseRate: "95%",
    onTimeDelivery: "96%",
    productCount: 680,
    categories: ["Jewellery", "Luxury Goods", "Gold"],
    description: "Premier gold and jewellery manufacturer based in Dubai Gold Souk. Crafting 18K and 22K gold pieces for wholesale buyers worldwide since 2005.",
    logo: "https://readdy.ai/api/search-image?query=luxury%20jewellery%20company%20logo%20gold%20emblem%20white%20background%20elegant%20corporate%20identity%20Dubai%20gold%20souk&width=80&height=80&seq=dfl3&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Dubai%20gold%20jewellery%20factory%20workshop%20craftsmen%20gold%20pieces%20luxury%20elegant%20professional%20bright%20interior&width=800&height=400&seq=dfc3&orientation=landscape",
    products: [
      {
        id: "df3p1",
        name: "22K Gold Arabic Bangle Set",
        samplePrice: 850,
        bulkPrice: 620,
        moq: 5,
        category: "Jewellery",
        image: "https://readdy.ai/api/search-image?query=22K%20gold%20Arabic%20bangle%20set%20luxury%20jewellery%20white%20background%20product%20photography%20premium%20elegant%20Middle%20East&width=400&height=400&seq=df3p1&orientation=squarish",
      },
      {
        id: "df3p2",
        name: "18K Gold Chain Necklace 50cm",
        samplePrice: 420,
        bulkPrice: 290,
        moq: 10,
        category: "Jewellery",
        image: "https://readdy.ai/api/search-image?query=18K%20gold%20chain%20necklace%2050cm%20luxury%20elegant%20white%20background%20product%20photography%20premium%20jewellery&width=400&height=400&seq=df3p2&orientation=squarish",
      },
      {
        id: "df3p3",
        name: "Gold-Plated Arabic Dallah Coffee Pot",
        samplePrice: 120,
        bulkPrice: 45,
        moq: 10,
        category: "Luxury Goods",
        image: "https://readdy.ai/api/search-image?query=gold%20plated%20Arabic%20dallah%20coffee%20pot%20luxury%20traditional%20Middle%20East%20product%20white%20background%20professional%20photography&width=400&height=400&seq=df3p3&orientation=squarish",
      },
    ],
  },
  {
    id: "df4",
    name: "Dubai Perfume & Oud Factory",
    city: "Dubai",
    established: 2012,
    employees: "100–200",
    verified: true,
    dropshipping: true,
    warehouseCountries: ["UAE", "Saudi Arabia", "Qatar", "UK", "France"],
    rating: 4.9,
    responseRate: "97%",
    onTimeDelivery: "95%",
    productCount: 420,
    categories: ["Beauty", "Fragrance", "Luxury"],
    description: "Authentic Arabic oud and perfume manufacturer. Supplying luxury fragrances to global retailers and dropshippers with private label options available.",
    logo: "https://readdy.ai/api/search-image?query=luxury%20perfume%20company%20logo%20gold%20oud%20emblem%20white%20background%20elegant%20corporate%20identity%20Dubai%20fragrance&width=80&height=80&seq=dfl4&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Dubai%20perfume%20oud%20factory%20production%20luxury%20fragrance%20bottles%20elegant%20interior%20professional%20bright%20clean&width=800&height=400&seq=dfc4&orientation=landscape",
    products: [
      {
        id: "df4p1",
        name: "Luxury Arabic Oud Perfume 100ml",
        samplePrice: 80,
        bulkPrice: 25,
        moq: 24,
        category: "Fragrance",
        image: "https://readdy.ai/api/search-image?query=luxury%20Arabic%20oud%20perfume%20bottle%20100ml%20gold%20elegant%20design%20white%20background%20product%20photography%20premium%20fragrance&width=400&height=400&seq=df4p1&orientation=squarish",
      },
      {
        id: "df4p2",
        name: "Dubai Oud Perfume Gift Set",
        samplePrice: 95,
        bulkPrice: 35,
        moq: 24,
        category: "Fragrance",
        image: "https://readdy.ai/api/search-image?query=Dubai%20oud%20perfume%20gift%20set%20luxury%20gold%20packaging%20white%20background%20product%20photography%20premium%20fragrance%20box&width=400&height=400&seq=df4p2&orientation=squarish",
      },
      {
        id: "df4p3",
        name: "Bakhoor Incense Chips 500g",
        samplePrice: 45,
        bulkPrice: 15,
        moq: 50,
        category: "Beauty",
        image: "https://readdy.ai/api/search-image?query=bakhoor%20incense%20chips%20500g%20Arabic%20luxury%20fragrance%20white%20background%20product%20photography%20premium%20Middle%20East&width=400&height=400&seq=df4p3&orientation=squarish",
      },
    ],
  },
  {
    id: "df5",
    name: "Jebel Ali Free Zone Textiles",
    city: "Jebel Ali",
    established: 2017,
    employees: "50–100",
    verified: false,
    dropshipping: true,
    warehouseCountries: ["UAE", "India", "Turkey"],
    rating: 4.4,
    responseRate: "85%",
    onTimeDelivery: "88%",
    productCount: 310,
    categories: ["Textiles", "Clothing", "Uniforms"],
    description: "Affordable textile and garment manufacturer in Jebel Ali Free Zone. Specializing in custom uniforms, sportswear, and bulk fabric orders.",
    logo: "https://readdy.ai/api/search-image?query=textile%20company%20logo%20gold%20thread%20emblem%20white%20background%20corporate%20identity%20Jebel%20Ali%20UAE%20fabric%20manufacturing&width=80&height=80&seq=dfl5&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=textile%20factory%20Jebel%20Ali%20UAE%20fabric%20production%20sewing%20machines%20workers%20professional%20bright%20interior&width=800&height=400&seq=dfc5&orientation=landscape",
    products: [
      {
        id: "df5p1",
        name: "Premium Arabic Thobe Fabric Roll",
        samplePrice: 25,
        bulkPrice: 8,
        moq: 100,
        category: "Textiles",
        image: "https://readdy.ai/api/search-image?query=premium%20white%20Arabic%20thobe%20fabric%20roll%20textile%20material%20clean%20white%20background%20product%20photography%20luxury&width=400&height=400&seq=df5p1&orientation=squarish",
      },
      {
        id: "df5p2",
        name: "Custom Sports Uniform Set",
        samplePrice: 35,
        bulkPrice: 12,
        moq: 20,
        category: "Clothing",
        image: "https://readdy.ai/api/search-image?query=custom%20sports%20uniform%20set%20jersey%20shorts%20professional%20athletic%20wear%20white%20background%20product%20photography%20clean&width=400&height=400&seq=df5p2&orientation=squarish",
      },
      {
        id: "df5p3",
        name: "Corporate Uniform Shirt (Custom Logo)",
        samplePrice: 22,
        bulkPrice: 8,
        moq: 50,
        category: "Uniforms",
        image: "https://readdy.ai/api/search-image?query=corporate%20uniform%20shirt%20custom%20logo%20professional%20white%20background%20product%20photography%20clean%20business%20workwear&width=400&height=400&seq=df5p3&orientation=squarish",
      },
    ],
  },
  {
    id: "df6",
    name: "UAE Packaging Solutions",
    city: "Sharjah",
    established: 2009,
    employees: "200–500",
    verified: true,
    dropshipping: false,
    rating: 4.6,
    responseRate: "90%",
    onTimeDelivery: "93%",
    productCount: 540,
    categories: ["Packaging", "Printing", "Logistics"],
    description: "Full-service packaging manufacturer in Sharjah. Producing food-grade, luxury, and industrial packaging for global export markets.",
    logo: "https://readdy.ai/api/search-image?query=packaging%20company%20logo%20gold%20box%20emblem%20white%20background%20corporate%20identity%20Sharjah%20UAE%20printing%20manufacturing&width=80&height=80&seq=dfl6&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=packaging%20factory%20Sharjah%20UAE%20production%20line%20boxes%20printing%20machines%20professional%20bright%20interior%20clean&width=800&height=400&seq=dfc6&orientation=landscape",
    products: [
      {
        id: "df6p1",
        name: "Food-Grade Packaging Containers Set",
        samplePrice: 8,
        bulkPrice: 2,
        moq: 500,
        category: "Packaging",
        image: "https://readdy.ai/api/search-image?query=food%20grade%20packaging%20containers%20set%20clear%20plastic%20white%20background%20product%20photography%20professional%20clean%20minimal&width=400&height=400&seq=df6p1&orientation=squarish",
      },
      {
        id: "df6p2",
        name: "Luxury Gift Box with Gold Foil",
        samplePrice: 12,
        bulkPrice: 4,
        moq: 200,
        category: "Packaging",
        image: "https://readdy.ai/api/search-image?query=luxury%20gift%20box%20gold%20foil%20embossing%20elegant%20packaging%20white%20background%20product%20photography%20premium&width=400&height=400&seq=df6p2&orientation=squarish",
      },
      {
        id: "df6p3",
        name: "Custom Printed Shipping Boxes",
        samplePrice: 5,
        bulkPrice: 1.5,
        moq: 1000,
        category: "Packaging",
        image: "https://readdy.ai/api/search-image?query=custom%20printed%20shipping%20boxes%20brown%20cardboard%20white%20background%20product%20photography%20professional%20packaging%20logistics&width=400&height=400&seq=df6p3&orientation=squarish",
      },
    ],
  },
];
